import getLocal from 'services/getLocal';

const authHeader = (): Record<string, string> => {
  const user = getLocal(localStorage).auth.getUser();
  if (user?.access_token) return {'Authorization': 'Bearer ' + user.access_token};
  return {'X-API-KEY': process.env.REACT_APP_API_KEY ?? ''};
};

export default authHeader;
